import { Tooltip, TooltipProps } from '@mui/material'

type ConsoleTooltipProps = TooltipProps & {
  distance?: number | 'auto'
  disableArrow?: boolean
  disabled?: boolean
  fontSize?: number
  maxWidth?: number
}

type TooltipMarginType = {
  marginTop?: number
  marginBottom?: number
  marginLeft?: number
  marginRight?: number
}

export const ConsoleTooltip = ({
  distance = 5,
  title,
  fontSize = 11,
  disabled = false,
  maxWidth = 300,
  placement = 'top',
  disableArrow = false,
  children,
  ...rest
}: ConsoleTooltipProps) => {
  const tooltipMargin: TooltipMarginType = {
    marginTop: undefined,
    marginBottom: undefined,
    marginLeft: undefined,
    marginRight: undefined
  }

  if (distance !== 'auto') {
    switch (placement) {
      case 'top':
        tooltipMargin.marginBottom = distance
        break
      case 'bottom':
        tooltipMargin.marginTop = distance
        break
      case 'left':
        tooltipMargin.marginRight = distance
        break
      case 'right':
        tooltipMargin.marginLeft = distance
        break
    }
  }

  return (
    <Tooltip
      title={!disabled && title ? title : ''}
      arrow={!disableArrow}
      placement={placement}
      {...rest}
      slotProps={{ tooltip: { style: { ...tooltipMargin, fontSize, maxWidth } } }}
    >
      {children}
    </Tooltip>
  )
}
